import { Component, OnInit, Input, ChangeDetectorRef, EventEmitter, ViewChild } from '@angular/core';
import { TableColumn, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Component({
    selector: 'generic-datagrid',
    templateUrl: './generic-datagrid.component.html',
    styleUrls: ['./generic-datagrid.component.scss'],
    standalone: false
})
export class GenericDatagridComponent implements OnInit {

  @Input("rows") rows:Object[] = [];
  @Input("headerHeight") headerHeight:number;
  @Input("rowHeight") rowHeight:number;
  @Input("columns") columns:TableColumn[];
  @Input("loadingIndicator") loadingIndicator:boolean = true; 
  @Input('gridDoubleClicked') gridDoubleClicked:BehaviorSubject<Boolean>;
  @ViewChild('dynamicTable')dynamicTable:DatatableComponent;

  SelectionType = SelectionType;


  public selectedRow:Object[] = [];

  constructor() {
   }

  ngOnInit() {
    this.rows = [...this.rows];
    
  }

  eventGrid( event:EventEmitter<Object>) {
    let type:String = event['type'];
    let eventType:Event = event['event'];
    let row:Object = event['row'];

    
    
    if ( type == "dblclick"|| type=="click"){

      if ( type == "dblclick"){
        this.gridDoubleClicked.next(true);
      }

      //this.selectedRow = [];
      //this.selectedRow.push(row);
    }

    if ( type == "mouseenter"){
      return;
    }
}


}
